import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import clockSketch from 'assets/img/sketches/recommendations-clock.svg';
import { ButtonVariant } from 'presentation/theme/components/button';
import { Rebalance } from 'model/modules/portfolio/rebalance';
import useCurrencyText from 'hooks/shared/useCurrencyText';

interface Props {
  rebalancing: Rebalance | null;
  onApproveClicked: () => void;
}

const HomeRecommendationsCard: FC<Props> = ({
  rebalancing,
  onApproveClicked,
}) => {
  const { t } = useTranslation();
  const currencyText = useCurrencyText();
  const navigate = useNavigate();

  return (
    <AppCard
      p="0"
      display="flex"
      justifyContent="space-between"
      bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
    >
      <Box
        p="15px"
        display="flex"
        flexDir="column"
        justifyContent="space-between"
      >
        <Box>
          <Text mb="10px" fontSize="18px" fontWeight={700} color="#fff">
            {t('newRecommendations')}
          </Text>
          <Text mb="8px" color="#fff">
            {t('pleaseApproveRebalancing')}
          </Text>
          <Box mb="25px">
            {rebalancing?.recommendations.map((order) => (
              <Flex key={order.id} alignItems="center">
                <Box
                  w="6px"
                  h="6px"
                  borderRadius="50%"
                  mr="6px"
                  ml="6px"
                  bgColor="#fff"
                />
                <Text color="#fff">{`${order.ticker} · ${currencyText(order.price, { symbol: order.currency.symbol })}`}</Text>
              </Flex>
            ))}
          </Box>
        </Box>
        <Flex>
          <Button
            variant={ButtonVariant.LightOutlined}
            onClick={() =>
              navigate(AppRoute.recommendations, {
                state: { tab: 'rebalance' },
              })
            }
            mr="15px"
          >
            {t('moreDetails')}
          </Button>
          <Button onClick={onApproveClicked}>
            {t('approveAllRecommendations')}
          </Button>
        </Flex>
      </Box>
      <Image src={clockSketch} w="200px" my="8px" />
    </AppCard>
  );
};

export default HomeRecommendationsCard;
